import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, NgModule, OnInit, output, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BxDropdownGenericModule, BxDropdownModule, DropdownValue } from '@buildxact/ui-components/bx-dropdowns';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LaunchDarklyService } from '../../../../../../core/services/launchdarkly.service';
import { System } from '../../../../../takeoff/core';
import { EstimatePlansTakeOffsStatesV2 } from '../../feat-estimate-plans-take-offs-v2/domain';
import {
    EstimateMeasurementDrawingStatus,
    EstimateMeasurementPrintModes,
    EstimateMeasurementViewSettings,
} from '../feat-estimate-measurements-v2/domain';

@Component({
    selector: 'app-estimate-measurements-settings',
    templateUrl: './estimate-measurements-settings.component.html',
    styleUrls: ['./estimate-measurements-settings.component.scss', '../../../../../../shared/composable-styles/dropdown-menu.scss'],
    standalone: false,
})
export class EstimateMeasurementsSettingsComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() states: EstimatePlansTakeOffsStatesV2;
    // @ts-ignore TS2564
    @Input() viewSettings: EstimateMeasurementViewSettings;
    // @ts-ignore TS2564
    @Input() measurementsDrawingStatus: EstimateMeasurementDrawingStatus;
    @Input() isExpanded = true;
    @Input() hasMeasurements = false;
    hasPlans = input<boolean>(false);

    @Output() addCategoryChanges = new EventEmitter();
    @Output() addMeasurementChanges = new EventEmitter();
    @Output() printChanges = new EventEmitter<EstimateMeasurementPrintModes>();
    @Output() emailChanges = new EventEmitter<EstimateMeasurementPrintModes>();
    @Output() toggleMeasurementsChanges = new EventEmitter();
    @Output() toggleAllTakeOffsChanges = new EventEmitter<boolean>();
    @Output() launchTakeoffsEvent = new EventEmitter();
    deleteAllMeasurementsChanges = output();

    // @ts-ignore TS2564
    public printActions: DropdownValue[];
    // @ts-ignore TS2564
    public emailActions: DropdownValue[];
    // @ts-ignore TS2564
    public uomOptions: DropdownValue[];

    public readonly takeOffSystems = System;

    isTakeoffsV2 = this.launchDarklyService.get('takeoffs-ui-uplift') ?? false;

    constructor(private readonly launchDarklyService: LaunchDarklyService) {}

    ngOnInit(): void {
        this.printActions = [
            { value: 'printMeasurements', label: 'Print take offs', condition: true },
            { value: 'printMeasurementsBreakdown', label: 'Print take offs breakdown', condition: true },
        ];

        this.emailActions = [
            { value: 'emailMeasurements', label: 'Email take offs', condition: true },
            { value: 'emailMeasurementsBreakdown', label: 'Email take offs breakdown', condition: true },
        ];
    }

    public addCategory() {
        this.addCategoryChanges.emit();
    }

    public addMeasurement() {
        this.addMeasurementChanges.emit();
    }

    public printMeasurements(printAction: string) {
        this.printChanges.emit(
            printAction === 'printMeasurements' ? EstimateMeasurementPrintModes.Default : EstimateMeasurementPrintModes.Breakdown
        );
    }

    public emailMeasurements(emailAction: string) {
        this.emailChanges.emit(
            emailAction === 'emailMeasurements' ? EstimateMeasurementPrintModes.Default : EstimateMeasurementPrintModes.Breakdown
        );
    }

    public toggleMeasurements() {
        this.toggleMeasurementsChanges.emit();
    }

    public toggleAllTakeOffs() {
        this.toggleAllTakeOffsChanges.emit(!this.measurementsDrawingStatus.hasShownDrawing);
    }

    launchTakeoffs() {
        this.launchTakeoffsEvent.emit();
    }

    deleteAllMeasurements() {
        this.deleteAllMeasurementsChanges.emit();
    }
}

@NgModule({
    declarations: [EstimateMeasurementsSettingsComponent],
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        MatButtonModule,
        BxDropdownModule,
        BxDropdownGenericModule,
        CdkMenuTrigger,
        CdkMenu,
        CdkMenuItem,
        TooltipModule,
    ],
    exports: [EstimateMeasurementsSettingsComponent],
})
export class EstimateMeasurementsSettingsModule {}
